// import {
//     createApp,
//     h
// } from 'vue';

// import LocomotiveScroll from 'locomotive-scroll';
// window.axios = require('axios');
// window.jQuery = window.$ = require('jquery');

// VueJS Components
// import ComponentA from './components/ComponentA.vue';

import {
	gsap
} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export class Setup {

	constructor() {
		gsap.registerPlugin(ScrollTrigger);

		// Vue JS
		// this.Vue();

		// For Locomotive Scroll
		// window.scroll = this.init();
		// this.smoothScroll();
		// this.onClick();
	}

	lazyLoad() {
		const el = document.querySelectorAll('.lazy');

		lozad(el, {
			load: function (el) {
				el.src = el.dataset.src;
				el.onload = function () {
					el.classList.add('focus')
				}
			}
		}).observe()
	}

	init() {
		window.locomotive = new LocomotiveScroll({
			el: document.querySelector('[data-scroll-container]'),
			smooth: true,
			getDirection: true,
		});

		return window.locomotive;
	}

	/**
	 * Smooth scroll to section.
	 */
	onClick() {
		let _this = this;
		let links = document.querySelectorAll('.menu-scroll')

		links.forEach((link) => {
			link.addEventListener('click', _this.scrollToSection);
		});
	}

	scrollToSection(e) {
		e.preventDefault();

		let navigation = document.querySelectorAll('nav.menu')[0];

		const href = this.getAttribute('href').replace('#', '.');
		const {
			offsetTop
		} = document.querySelector(`${href}`);

		if (navigation.classList.contains('open')) {
			navigation.classList.remove('open');
		}

		window.locomotive.scrollTo(offsetTop);
	}

	/**
	 * Smooth scroll container.
	 */
	smoothScroll() {

		/**
		 * Add page direction on scroll.
		 */
		scroll.on('scroll', (instance) => {
			document.documentElement.setAttribute('data-direction', instance.direction);

			if (instance.scroll.y > 105 && window.screen.width > 480) {
				document.documentElement.classList.add('direction');
			} else {
				document.documentElement.classList.remove('direction');
			}
		});

		/**
		 * Scroll Trigger Proxy
		 */
		ScrollTrigger.scrollerProxy('[data-scroll-container]', {
			scrollTop(value) {
				return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
			},
			getBoundingClientRect() {
				return {
					top: 0,
					left: 0,
					width: window.innerWidth,
					height: window.innerHeight
				};
			},
			pinType: document.querySelector('[data-scroll-container]').style.transform ? 'transform' : 'fixed'
		});

	}

	scrollTriggerRefresh() {
		ScrollTrigger.addEventListener('refresh', () => scroll.update());
		ScrollTrigger.refresh();
	}

	/**
	 * VueJS & Axios setup.
	 * 
	 * Un-comment this and the import above to use
	 * components.
	 */
	// Vue() {
	//     axios.defaults.baseURL = process.env.API_URL;

	//     const app = createApp({
	//         components: {
	//             'component-a': ComponentA,
	//         }
	//     });

	//     app.mount('#app')
	//     app.config.devtools = true;

	//     console.log('VueJS is ready.');
	// }
}